<!--
    Panel kontrolny - wszystkie przyciski wyboru z UI poza Pano
-->

<template>
    <div class="ControlPanel">
        <Series :scene="scene" />
        <TexturesPanel :scene="scene" />
    </div>
</template>

<script>
    import Series from './Series.vue';
    import TexturesPanel from './TexturesPanel.vue';

    export default {
        name: 'ControlPanel',

        props: {
            scene: String,
        },
        data() {
            return {

            }
        },
        components: {
            Series,
            TexturesPanel,
        },
        methods: {
        }
    };
</script>

<style scoped>
    .ControlPanel {
        text-align: right;
    }
</style>